export default "__VITE_ASSET__ByN5jB2A__"